// GENERATED by scripts/gen-security-baseline.mjs from
// db/content/security-baseline-crosswalk.json — do not hand-edit.
// v9.6 / ADR-0044: organization-wide security baseline (OGCF SEC-*) and
// its crosswalk to SOC 2 TSC and FedRAMP CR26 KSIs. The DB rows (migration
// 205) are the runtime truth; this module lets collectors and tests
// reference controls without a query.
export const SECURITY_BASELINE_VERSION = "v96.1";
export const SECURITY_BASELINE_BATCH_ID = "crosswalk-v96@1";
export const SECURITY_BASELINE_CONTROLS = [
    {
        "id": "SEC-IAM-01",
        "domain": "access_control",
        "title": "Workforce MFA enforced",
        "mode": "machine",
        "description": "Multi-factor authentication is enforced for all workforce identities at the identity provider."
    },
    {
        "id": "SEC-IAM-02",
        "domain": "access_control",
        "title": "Phishing-resistant or passwordless authentication",
        "mode": "machine",
        "description": "Workforce sign-in uses passwordless or phishing-resistant factors (FIDO2/WebAuthn, platform authenticators)."
    },
    {
        "id": "SEC-IAM-03",
        "domain": "access_control",
        "title": "Automated account lifecycle",
        "mode": "machine",
        "description": "Joiner/mover/leaver changes are provisioned and deprovisioned automatically from an authoritative source, within a defined window."
    },
    {
        "id": "SEC-IAM-04",
        "domain": "access_control",
        "title": "Periodic user access review",
        "mode": "attested",
        "description": "User and privileged access is reviewed on a defined cadence and inappropriate access is removed."
    },
    {
        "id": "SEC-IAM-05",
        "domain": "access_control",
        "title": "Least privilege and minimal administrators",
        "mode": "machine",
        "description": "Roles grant only needed permissions; administrative accounts are few, named, and monitored."
    },
    {
        "id": "SEC-IAM-06",
        "domain": "access_control",
        "title": "Just-in-time privileged access",
        "mode": "machine",
        "description": "Privileged access is requested, approved, time-bound, and revoked automatically."
    },
    {
        "id": "SEC-IAM-07",
        "domain": "access_control",
        "title": "Service account credential security",
        "mode": "machine",
        "description": "Non-user accounts use short-lived or federated credentials; long-lived keys are inventoried, restricted, and rotated."
    },
    {
        "id": "SEC-IAM-08",
        "domain": "access_control",
        "title": "Suspicious activity lockout",
        "mode": "attested",
        "description": "Privileged accounts are disabled or secured automatically or by runbook when suspicious activity is detected."
    },
    {
        "id": "SEC-IAM-09",
        "domain": "access_control",
        "title": "Secrets management and rotation",
        "mode": "machine",
        "description": "Keys, certificates and secrets live in a managed store, are rotated on schedule, and are scanned for in source code."
    },
    {
        "id": "SEC-LOG-01",
        "domain": "audit_logging",
        "title": "Centralized tamper-resistant logging",
        "mode": "machine",
        "description": "Security-relevant logs are collected centrally (SIEM or equivalent) with integrity protection and retention."
    },
    {
        "id": "SEC-LOG-02",
        "domain": "audit_logging",
        "title": "Logged event inventory",
        "mode": "attested",
        "description": "A maintained list defines which resources and event types are logged, monitored and audited."
    },
    {
        "id": "SEC-LOG-03",
        "domain": "audit_logging",
        "title": "Log review and alerting",
        "mode": "machine",
        "description": "Logs are reviewed and alert on anomalous or security-relevant activity."
    },
    {
        "id": "SEC-LOG-04",
        "domain": "audit_logging",
        "title": "Restricted access to log data",
        "mode": "machine",
        "description": "Access to log data follows least privilege and is itself logged."
    },
    {
        "id": "SEC-CHG-01",
        "domain": "change_management",
        "title": "Peer-reviewed changes with branch protection",
        "mode": "machine",
        "description": "Production changes require review by someone other than the author and merge only through protected branches."
    },
    {
        "id": "SEC-CHG-02",
        "domain": "change_management",
        "title": "Automated testing in the deployment pipeline",
        "mode": "machine",
        "description": "Changes pass automated tests and security checks in CI/CD before and during deployment."
    },
    {
        "id": "SEC-CHG-03",
        "domain": "change_management",
        "title": "Redeploy from version control",
        "mode": "machine",
        "description": "Infrastructure and services change by redeploying version-controlled definitions, not by direct modification."
    },
    {
        "id": "SEC-CHG-04",
        "domain": "change_management",
        "title": "Change logging and monitoring",
        "mode": "machine",
        "description": "Modifications to production resources are logged and monitored for unauthorized change."
    },
    {
        "id": "SEC-CHG-05",
        "domain": "change_management",
        "title": "Change procedure review",
        "mode": "attested",
        "description": "Documented change management procedures are reviewed for effectiveness on a defined cadence, including residual-risk cleanup after changes."
    },
    {
        "id": "SEC-CFG-01",
        "domain": "configuration",
        "title": "Automated configuration and drift enforcement",
        "mode": "machine",
        "description": "Resource configuration is managed as code and continuously assessed; drift from the intended state is detected and corrected."
    },
    {
        "id": "SEC-CFG-02",
        "domain": "configuration",
        "title": "Provider best-practice benchmarks",
        "mode": "machine",
        "description": "Cloud and third-party service configuration is continuously compared to provider security best practices."
    },
    {
        "id": "SEC-CFG-03",
        "domain": "network",
        "title": "Network traffic restriction and segmentation",
        "mode": "machine",
        "description": "Inbound and outbound traffic is restricted to what is needed and logical networking enforces flow controls between segments."
    },
    {
        "id": "SEC-CFG-04",
        "domain": "configuration",
        "title": "Attack surface minimization",
        "mode": "machine",
        "description": "Resources expose only required functionality and privileges; hardening limits lateral movement if compromised."
    },
    {
        "id": "SEC-CFG-05",
        "domain": "network",
        "title": "Edge and denial-of-service protection",
        "mode": "machine",
        "description": "Protections against denial of service and unwanted traffic are in place and reviewed for effectiveness."
    },
    {
        "id": "SEC-CFG-06",
        "domain": "asset_management",
        "title": "Automated asset inventory",
        "mode": "machine",
        "description": "An authoritative, automatically generated inventory of information resources is available on demand."
    },
    {
        "id": "SEC-DAT-01",
        "domain": "data_protection",
        "title": "Encryption at rest",
        "mode": "machine",
        "description": "Stored data is encrypted with managed keys."
    },
    {
        "id": "SEC-DAT-02",
        "domain": "data_protection",
        "title": "Authenticated encrypted communications",
        "mode": "machine",
        "description": "Data in transit is encrypted, and communications between services are mutually authenticated and integrity-checked."
    },
    {
        "id": "SEC-DAT-03",
        "domain": "data_protection",
        "title": "Data classification and handling",
        "mode": "attested",
        "description": "Data is classified and handling rules, including transmission and movement restrictions, follow the classification."
    },
    {
        "id": "SEC-DAT-04",
        "domain": "data_protection",
        "title": "Retention and secure disposal",
        "mode": "attested",
        "description": "Data is retained only as long as required and is disposed of securely, including customer-requested removal and removal from backups where agreed."
    },
    {
        "id": "SEC-DAT-05",
        "domain": "data_protection",
        "title": "Cryptographic integrity of resources",
        "mode": "machine",
        "description": "Software and resource integrity is validated cryptographically (signing, attestation, hash verification)."
    },
    {
        "id": "SEC-VUL-01",
        "domain": "vulnerability_management",
        "title": "Continuous vulnerability scanning",
        "mode": "machine",
        "description": "Infrastructure, images and applications are scanned continuously for vulnerabilities and misconfiguration."
    },
    {
        "id": "SEC-VUL-02",
        "domain": "vulnerability_management",
        "title": "Remediation within defined timeframes",
        "mode": "machine",
        "description": "Vulnerabilities are remediated or formally accepted within timeframes set by severity and exposure."
    },
    {
        "id": "SEC-VUL-03",
        "domain": "vulnerability_management",
        "title": "Third-party component monitoring",
        "mode": "machine",
        "description": "Third-party software and dependencies are inventoried and monitored for upstream and known-exploited vulnerabilities."
    },
    {
        "id": "SEC-VUL-04",
        "domain": "vulnerability_management",
        "title": "Vulnerability disclosure program",
        "mode": "attested",
        "description": "A public vulnerability disclosure channel exists and its handling is reviewed."
    },
    {
        "id": "SEC-VUL-05",
        "domain": "vulnerability_management",
        "title": "Independent penetration testing",
        "mode": "attested",
        "description": "Independent penetration tests are performed on a defined cadence and findings are tracked to closure."
    },
    {
        "id": "SEC-INC-01",
        "domain": "incident_response",
        "title": "Incident response plan and exercises",
        "mode": "attested",
        "description": "A documented incident response plan is maintained, exercised, and reviewed for effectiveness."
    },
    {
        "id": "SEC-INC-02",
        "domain": "incident_response",
        "title": "Security event triage",
        "mode": "attested",
        "description": "Security events are evaluated promptly to decide whether they are incidents, with severity assigned."
    },
    {
        "id": "SEC-INC-03",
        "domain": "incident_response",
        "title": "Post-incident review and trend analysis",
        "mode": "attested",
        "description": "After-action reviews are produced for incidents, past incidents are analyzed for patterns, and lessons are fed back."
    },
    {
        "id": "SEC-INC-04",
        "domain": "incident_response",
        "title": "Incident and breach notification",
        "mode": "attested",
        "description": "Customers, regulators and affected parties are notified of incidents and breaches within required timeframes."
    },
    {
        "id": "SEC-BCP-01",
        "domain": "resilience",
        "title": "Backups aligned to recovery objectives",
        "mode": "machine",
        "description": "Backups run on schedules and retention that meet defined recovery point objectives and are protected from tampering."
    },
    {
        "id": "SEC-BCP-02",
        "domain": "resilience",
        "title": "Recovery objectives and plan",
        "mode": "attested",
        "description": "Recovery time and point objectives are defined from business needs and the recovery plan is kept aligned with them."
    },
    {
        "id": "SEC-BCP-03",
        "domain": "resilience",
        "title": "Recovery and DR testing",
        "mode": "attested",
        "description": "Recovery capability is tested against the defined objectives on a defined cadence."
    },
    {
        "id": "SEC-BCP-04",
        "domain": "resilience",
        "title": "Capacity and availability monitoring",
        "mode": "machine",
        "description": "Capacity and availability are monitored against commitments, with redundancy for rapid recovery."
    },
    {
        "id": "SEC-HR-01",
        "domain": "people",
        "title": "Security awareness training",
        "mode": "attested",
        "description": "All personnel complete security training at hire and annually; role-specific training covers privileged roles; effectiveness is reviewed."
    },
    {
        "id": "SEC-HR-02",
        "domain": "people",
        "title": "Background screening",
        "mode": "attested",
        "description": "Personnel are screened before access to production or customer data, as permitted by law."
    },
    {
        "id": "SEC-HR-03",
        "domain": "people",
        "title": "Onboarding and offboarding",
        "mode": "attested",
        "description": "Hiring and separation follow checklists covering access, assets, and confidentiality obligations."
    },
    {
        "id": "SEC-HR-04",
        "domain": "people",
        "title": "Code of conduct acknowledgment",
        "mode": "attested",
        "description": "Personnel acknowledge the code of conduct and are held accountable for violations."
    },
    {
        "id": "SEC-GOV-01",
        "domain": "governance",
        "title": "Approved and acknowledged security policies",
        "mode": "attested",
        "description": "Information security policies are approved by management, published, reviewed annually, and acknowledged by personnel."
    },
    {
        "id": "SEC-GOV-02",
        "domain": "governance",
        "title": "Executive oversight of security",
        "mode": "attested",
        "description": "Leadership and the board oversee the security program, its goals and its resourcing, independently of management."
    },
    {
        "id": "SEC-GOV-03",
        "domain": "governance",
        "title": "Annual risk assessment including fraud",
        "mode": "attested",
        "description": "Objectives are set and risks, including fraud and significant changes, are identified, analyzed and treated at least annually."
    },
    {
        "id": "SEC-GOV-04",
        "domain": "third_party",
        "title": "Vendor risk management",
        "mode": "attested",
        "description": "Vendors and partners are assessed before onboarding and periodically, with security terms in agreements."
    },
    {
        "id": "SEC-GOV-05",
        "domain": "governance",
        "title": "Secure development lifecycle",
        "mode": "attested",
        "description": "Security and privacy are built into the SDLC in line with Secure by Design principles, and the practice is reviewed."
    },
    {
        "id": "SEC-GOV-06",
        "domain": "governance",
        "title": "Control monitoring and deficiency tracking",
        "mode": "machine",
        "description": "Controls are evaluated continuously and deficiencies are tracked to remediation with owners and deadlines."
    },
    {
        "id": "SEC-GOV-07",
        "domain": "governance",
        "title": "Security roles and accountability",
        "mode": "attested",
        "description": "Security responsibilities, reporting lines and authorities are defined and people are held accountable for them."
    },
    {
        "id": "SEC-GOV-08",
        "domain": "governance",
        "title": "External security commitments",
        "mode": "attested",
        "description": "Security commitments, system changes and incidents are communicated to customers and external parties."
    },
    {
        "id": "SEC-PHY-01",
        "domain": "physical",
        "title": "Physical access controls",
        "mode": "attested",
        "description": "Facilities and hosting environments restrict physical access; for cloud-hosted systems this is inherited from and verified against the provider's attestation."
    },
    {
        "id": "SEC-PRV-01",
        "domain": "privacy",
        "title": "Privacy notice",
        "mode": "attested",
        "description": "Data subjects receive a notice describing collection, use, retention and disclosure of their personal information."
    },
    {
        "id": "SEC-PRV-02",
        "domain": "privacy",
        "title": "Choice and consent",
        "mode": "attested",
        "description": "Choices about personal information are offered and consent is obtained, including explicit consent where required."
    },
    {
        "id": "SEC-PRV-03",
        "domain": "privacy",
        "title": "Collection and use limitation",
        "mode": "attested",
        "description": "Personal information is collected and used only for the purposes stated in the notice."
    },
    {
        "id": "SEC-PRV-04",
        "domain": "privacy",
        "title": "Data subject access and correction",
        "mode": "attested",
        "description": "Data subjects can access their personal information and request corrections, which are handled on time."
    },
    {
        "id": "SEC-PRV-05",
        "domain": "privacy",
        "title": "Third-party disclosure management",
        "mode": "attested",
        "description": "Disclosures to third parties follow consent and contracts; disclosures, including unauthorized ones, are recorded and third parties must report incidents."
    },
    {
        "id": "SEC-PRV-06",
        "domain": "privacy",
        "title": "Personal data quality",
        "mode": "attested",
        "description": "Personal information is kept accurate, complete and relevant for its purposes."
    },
    {
        "id": "SEC-PRV-07",
        "domain": "privacy",
        "title": "Privacy inquiries and complaints",
        "mode": "attested",
        "description": "Privacy inquiries, complaints and disputes are received, tracked and resolved."
    },
    {
        "id": "SEC-PI-01",
        "domain": "processing_integrity",
        "title": "Processing specifications",
        "mode": "attested",
        "description": "Processing objectives, data definitions and specifications are documented and communicated."
    },
    {
        "id": "SEC-PI-02",
        "domain": "processing_integrity",
        "title": "Input validation",
        "mode": "attested",
        "description": "Inputs are validated for completeness and accuracy before processing."
    },
    {
        "id": "SEC-PI-03",
        "domain": "processing_integrity",
        "title": "Processing controls",
        "mode": "attested",
        "description": "Processing is monitored so results are complete, accurate and timely, and errors are corrected."
    },
    {
        "id": "SEC-PI-04",
        "domain": "processing_integrity",
        "title": "Output review and delivery",
        "mode": "attested",
        "description": "Outputs are reviewed for completeness and accuracy and delivered only to intended recipients."
    },
    {
        "id": "SEC-PI-05",
        "domain": "processing_integrity",
        "title": "Storage integrity of processed data",
        "mode": "attested",
        "description": "Inputs, in-process items and outputs are stored completely and accurately and protected from unauthorized change."
    }
];
export const SECURITY_BASELINE_EDGES = [
    ["SEC-HR-04", "soc2:CC1.1", "partial"],
    ["SEC-GOV-01", "soc2:CC1.1", "partial"],
    ["SEC-GOV-02", "soc2:CC1.2", "subsumes"],
    ["SEC-GOV-07", "soc2:CC1.3", "subsumes"],
    ["SEC-HR-01", "soc2:CC1.4", "partial"],
    ["SEC-HR-02", "soc2:CC1.4", "partial"],
    ["SEC-HR-03", "soc2:CC1.4", "partial"],
    ["SEC-GOV-07", "soc2:CC1.5", "partial"],
    ["SEC-HR-04", "soc2:CC1.5", "partial"],
    ["SEC-LOG-02", "soc2:CC2.1", "partial"],
    ["SEC-CFG-06", "soc2:CC2.1", "partial"],
    ["SEC-GOV-06", "soc2:CC2.1", "partial"],
    ["SEC-GOV-01", "soc2:CC2.2", "partial"],
    ["SEC-HR-01", "soc2:CC2.2", "partial"],
    ["SEC-GOV-08", "soc2:CC2.3", "subsumes"],
    ["SEC-GOV-03", "soc2:CC3.1", "subsumes"],
    ["SEC-GOV-03", "soc2:CC3.2", "partial"],
    ["SEC-GOV-04", "soc2:CC3.2", "partial"],
    ["SEC-GOV-03", "soc2:CC3.3", "subsumes"],
    ["SEC-GOV-03", "soc2:CC3.4", "partial"],
    ["SEC-CHG-05", "soc2:CC3.4", "partial"],
    ["SEC-GOV-06", "soc2:CC4.1", "partial"],
    ["SEC-VUL-05", "soc2:CC4.1", "partial"],
    ["SEC-GOV-06", "soc2:CC4.2", "subsumes"],
    ["SEC-GOV-03", "soc2:CC5.1", "partial"],
    ["SEC-GOV-06", "soc2:CC5.1", "partial"],
    ["SEC-CFG-01", "soc2:CC5.2", "partial"],
    ["SEC-CHG-01", "soc2:CC5.2", "partial"],
    ["SEC-IAM-05", "soc2:CC5.2", "partial"],
    ["SEC-GOV-01", "soc2:CC5.3", "subsumes"],
    ["SEC-IAM-01", "soc2:CC6.1", "partial"],
    ["SEC-IAM-05", "soc2:CC6.1", "partial"],
    ["SEC-CFG-03", "soc2:CC6.1", "partial"],
    ["SEC-DAT-01", "soc2:CC6.1", "partial"],
    ["SEC-IAM-09", "soc2:CC6.1", "partial"],
    ["SEC-CFG-06", "soc2:CC6.1", "partial"],
    ["SEC-IAM-03", "soc2:CC6.2", "partial"],
    ["SEC-IAM-04", "soc2:CC6.2", "partial"],
    ["SEC-IAM-03", "soc2:CC6.3", "partial"],
    ["SEC-IAM-04", "soc2:CC6.3", "partial"],
    ["SEC-IAM-05", "soc2:CC6.3", "partial"],
    ["SEC-PHY-01", "soc2:CC6.4", "subsumes"],
    ["SEC-DAT-04", "soc2:CC6.5", "subsumes"],
    ["SEC-CFG-03", "soc2:CC6.6", "partial"],
    ["SEC-CFG-05", "soc2:CC6.6", "partial"],
    ["SEC-IAM-01", "soc2:CC6.6", "partial"],
    ["SEC-DAT-02", "soc2:CC6.7", "partial"],
    ["SEC-DAT-03", "soc2:CC6.7", "partial"],
    ["SEC-VUL-01", "soc2:CC6.8", "partial"],
    ["SEC-CFG-04", "soc2:CC6.8", "partial"],
    ["SEC-VUL-03", "soc2:CC6.8", "partial"],
    ["SEC-CFG-01", "soc2:CC7.1", "partial"],
    ["SEC-VUL-01", "soc2:CC7.1", "partial"],
    ["SEC-LOG-01", "soc2:CC7.2", "partial"],
    ["SEC-LOG-03", "soc2:CC7.2", "partial"],
    ["SEC-INC-02", "soc2:CC7.3", "subsumes"],
    ["SEC-INC-01", "soc2:CC7.4", "partial"],
    ["SEC-INC-04", "soc2:CC7.4", "partial"],
    ["SEC-INC-03", "soc2:CC7.5", "partial"],
    ["SEC-BCP-03", "soc2:CC7.5", "partial"],
    ["SEC-CHG-01", "soc2:CC8.1", "partial"],
    ["SEC-CHG-02", "soc2:CC8.1", "partial"],
    ["SEC-CHG-04", "soc2:CC8.1", "partial"],
    ["SEC-BCP-02", "soc2:CC9.1", "partial"],
    ["SEC-BCP-03", "soc2:CC9.1", "partial"],
    ["SEC-GOV-03", "soc2:CC9.1", "partial"],
    ["SEC-GOV-04", "soc2:CC9.2", "subsumes"],
    ["SEC-BCP-04", "soc2:A1.1", "subsumes"],
    ["SEC-BCP-01", "soc2:A1.2", "partial"],
    ["SEC-PHY-01", "soc2:A1.2", "partial"],
    ["SEC-BCP-03", "soc2:A1.3", "subsumes"],
    ["SEC-DAT-03", "soc2:C1.1", "partial"],
    ["SEC-DAT-01", "soc2:C1.1", "partial"],
    ["SEC-DAT-04", "soc2:C1.2", "subsumes"],
    ["SEC-PI-01", "soc2:PI1.1", "subsumes"],
    ["SEC-PI-02", "soc2:PI1.2", "subsumes"],
    ["SEC-PI-03", "soc2:PI1.3", "subsumes"],
    ["SEC-PI-04", "soc2:PI1.4", "subsumes"],
    ["SEC-PI-05", "soc2:PI1.5", "partial"],
    ["SEC-BCP-01", "soc2:PI1.5", "partial"],
    ["SEC-PRV-01", "soc2:P1.1", "subsumes"],
    ["SEC-PRV-02", "soc2:P2.1", "subsumes"],
    ["SEC-PRV-03", "soc2:P3.1", "subsumes"],
    ["SEC-PRV-02", "soc2:P3.2", "subsumes"],
    ["SEC-PRV-03", "soc2:P4.1", "subsumes"],
    ["SEC-DAT-04", "soc2:P4.2", "subsumes"],
    ["SEC-DAT-04", "soc2:P4.3", "subsumes"],
    ["SEC-PRV-04", "soc2:P5.1", "subsumes"],
    ["SEC-PRV-04", "soc2:P5.2", "subsumes"],
    ["SEC-PRV-05", "soc2:P6.1", "subsumes"],
    ["SEC-PRV-05", "soc2:P6.2", "subsumes"],
    ["SEC-PRV-05", "soc2:P6.3", "subsumes"],
    ["SEC-PRV-05", "soc2:P6.4", "subsumes"],
    ["SEC-PRV-05", "soc2:P6.5", "subsumes"],
    ["SEC-INC-04", "soc2:P6.6", "subsumes"],
    ["SEC-PRV-05", "soc2:P6.7", "partial"],
    ["SEC-PRV-04", "soc2:P6.7", "partial"],
    ["SEC-PRV-06", "soc2:P7.1", "subsumes"],
    ["SEC-PRV-07", "soc2:P8.1", "subsumes"],
    ["SEC-HR-01", "fedramp-cr26:KSI-CED-RAT", "subsumes"],
    ["SEC-CHG-04", "fedramp-cr26:KSI-CMT-LMC", "subsumes"],
    ["SEC-CHG-03", "fedramp-cr26:KSI-CMT-RMV", "subsumes"],
    ["SEC-CHG-05", "fedramp-cr26:KSI-CMT-RVP", "subsumes"],
    ["SEC-CHG-02", "fedramp-cr26:KSI-CMT-VTD", "subsumes"],
    ["SEC-IAM-05", "fedramp-cr26:KSI-CNA-DFP", "partial"],
    ["SEC-CFG-04", "fedramp-cr26:KSI-CNA-DFP", "partial"],
    ["SEC-CFG-01", "fedramp-cr26:KSI-CNA-EIS", "subsumes"],
    ["SEC-CFG-02", "fedramp-cr26:KSI-CNA-IBP", "subsumes"],
    ["SEC-CFG-04", "fedramp-cr26:KSI-CNA-MAT", "subsumes"],
    ["SEC-BCP-04", "fedramp-cr26:KSI-CNA-OFA", "partial"],
    ["SEC-BCP-01", "fedramp-cr26:KSI-CNA-OFA", "partial"],
    ["SEC-CFG-03", "fedramp-cr26:KSI-CNA-RNT", "subsumes"],
    ["SEC-CFG-05", "fedramp-cr26:KSI-CNA-RVP", "subsumes"],
    ["SEC-CFG-03", "fedramp-cr26:KSI-CNA-ULN", "subsumes"],
    ["SEC-IAM-03", "fedramp-cr26:KSI-IAM-AAM", "subsumes"],
    ["SEC-IAM-02", "fedramp-cr26:KSI-IAM-APM", "subsumes"],
    ["SEC-IAM-05", "fedramp-cr26:KSI-IAM-ELP", "partial"],
    ["SEC-IAM-04", "fedramp-cr26:KSI-IAM-ELP", "partial"],
    ["SEC-IAM-06", "fedramp-cr26:KSI-IAM-JIT", "subsumes"],
    ["SEC-IAM-07", "fedramp-cr26:KSI-IAM-SNU", "subsumes"],
    ["SEC-IAM-08", "fedramp-cr26:KSI-IAM-SUS", "subsumes"],
    ["SEC-INC-03", "fedramp-cr26:KSI-INR-AAR", "subsumes"],
    ["SEC-INC-01", "fedramp-cr26:KSI-INR-RIR", "subsumes"],
    ["SEC-INC-03", "fedramp-cr26:KSI-INR-RPI", "subsumes"],
    ["SEC-LOG-04", "fedramp-cr26:KSI-MLA-ALA", "subsumes"],
    ["SEC-CFG-01", "fedramp-cr26:KSI-MLA-EVC", "partial"],
    ["SEC-CHG-02", "fedramp-cr26:KSI-MLA-EVC", "partial"],
    ["SEC-LOG-02", "fedramp-cr26:KSI-MLA-LET", "subsumes"],
    ["SEC-LOG-01", "fedramp-cr26:KSI-MLA-OSM", "partial"],
    ["SEC-LOG-03", "fedramp-cr26:KSI-MLA-OSM", "partial"],
    ["SEC-LOG-03", "fedramp-cr26:KSI-MLA-RVL", "subsumes"],
    ["SEC-CFG-06", "fedramp-cr26:KSI-PIY-GIV", "subsumes"],
    ["SEC-GOV-02", "fedramp-cr26:KSI-PIY-RES", "subsumes"],
    ["SEC-GOV-02", "fedramp-cr26:KSI-PIY-RIS", "subsumes"],
    ["SEC-GOV-05", "fedramp-cr26:KSI-PIY-RSD", "subsumes"],
    ["SEC-VUL-04", "fedramp-cr26:KSI-PIY-RVD", "subsumes"],
    ["SEC-BCP-01", "fedramp-cr26:KSI-RPL-ABO", "subsumes"],
    ["SEC-BCP-02", "fedramp-cr26:KSI-RPL-ARP", "subsumes"],
    ["SEC-BCP-02", "fedramp-cr26:KSI-RPL-RRO", "subsumes"],
    ["SEC-BCP-03", "fedramp-cr26:KSI-RPL-TRC", "subsumes"],
    ["SEC-GOV-04", "fedramp-cr26:KSI-SCR-MIT", "partial"],
    ["SEC-VUL-03", "fedramp-cr26:KSI-SCR-MIT", "partial"],
    ["SEC-VUL-03", "fedramp-cr26:KSI-SCR-MON", "subsumes"],
    ["SEC-CFG-01", "fedramp-cr26:KSI-SVC-ACM", "subsumes"],
    ["SEC-IAM-09", "fedramp-cr26:KSI-SVC-ASM", "subsumes"],
    ["SEC-GOV-06", "fedramp-cr26:KSI-SVC-EIS", "partial"],
    ["SEC-VUL-02", "fedramp-cr26:KSI-SVC-EIS", "partial"],
    ["SEC-CHG-05", "fedramp-cr26:KSI-SVC-PRR", "partial"],
    ["SEC-CFG-01", "fedramp-cr26:KSI-SVC-PRR", "partial"],
    ["SEC-DAT-04", "fedramp-cr26:KSI-SVC-RUD", "subsumes"],
    ["SEC-DAT-01", "fedramp-cr26:KSI-SVC-SIN", "partial"],
    ["SEC-DAT-02", "fedramp-cr26:KSI-SVC-SIN", "partial"],
    ["SEC-DAT-02", "fedramp-cr26:KSI-SVC-VCM", "subsumes"],
    ["SEC-DAT-05", "fedramp-cr26:KSI-SVC-VRI", "subsumes"],
];
//# sourceMappingURL=security-baseline.js.map